import {
  CLEAR_RPOJECT,

  GET_PROJECT_LOADING,
  GET_PROJECT_FULFILLED,
  GET_PROJECT_REJECTED,

  PUT_PROJECT_NAME_LOADING,
  PUT_PROJECT_NAME_FULFILLED,
  PUT_PROJECT_NAME_REJECTED,

  PUT_PROJECT_MODEL_DRAFT_LOADING,
  PUT_PROJECT_MODEL_DRAFT_FULFILLED,
  PUT_PROJECT_MODEL_DRAFT_REJECTED,

  CREATE_PROJECT_LOADING,
  CREATE_PROJECT_FULFILLED,
  CREATE_PROJECT_REJECTED,

  PUT_PROJECT_MODEL_VALIDATE_LOADING,
  PUT_PROJECT_MODEL_VALIDATE_FULFILLED,
  PUT_PROJECT_MODEL_VALIDATE_REJECTED,

  GET_LAYER_RECO_LOADING,
  GET_LAYER_RECO_FULFILLED,
  GET_LAYER_RECO_REJECTED,

  GET_PROJECT_REMOVE_LOADING,
  GET_PROJECT_REMOVE_FULFILLED,
  GET_PROJECT_REMOVE_REJECTED,

  GET_PROJECT_DUPLICATE_LOADING,
  GET_PROJECT_DUPLICATE_FULFILLED,
  GET_PROJECT_DUPLICATE_REJECTED,

  GET_PROJECT_DOWNLOAD_LOADING,
  GET_PROJECT_DOWNLOAD_FULFILLED,
  GET_PROJECT_DOWNLOAD_REJECTED,

} from 'actions/project/project.actions';

const initialState = {
  data: {},
  loading: false,
  editingName: false,
  editingModelDraft: false,

  createProjectLoading: false,
  createProjectId: null,

  validateLoading: false,

  recommendations: [],
  recommendationsLoading: false,

};

const projectDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_RPOJECT:
      return initialState;

    case GET_PROJECT_LOADING:
      return {
        ...state,
        loading: true,
      };
    case GET_PROJECT_FULFILLED:
      return {
        ...state,
        loading: false,
        data: action.data.project,
        errors: null,
      };
    case GET_PROJECT_REJECTED:
      return {
        ...state,
        ...initialState,
        loading: false,
        errors: action.data,
      };
    case PUT_PROJECT_NAME_LOADING:
      return {
        ...state,
        editingName: true,
      };
    case PUT_PROJECT_NAME_FULFILLED:
      return {
        ...state,
        editingName: false,
        data: action.data.project,
      };
    case PUT_PROJECT_NAME_REJECTED:
      return {
        ...state,
        ...initialState,
        editingName: false,
      };

    case PUT_PROJECT_MODEL_DRAFT_LOADING:
      return {
        ...state,
        editingModelDraft: true,
      };
    case PUT_PROJECT_MODEL_DRAFT_FULFILLED:
      return {
        ...state,
        editingModelDraft: false,
        data: action.data.project,
      };
    case PUT_PROJECT_MODEL_DRAFT_REJECTED:
      return {
        ...state,
        ...initialState,
        editingModelDraft: false,
      };

    case CREATE_PROJECT_LOADING:
      return {
        ...state,
        createProjectLoading: true,
        createProjectId: null,
      };
    case CREATE_PROJECT_FULFILLED:
      return {
        ...state,
        createProjectLoading: false,
        createProjectId: action.data.project?.id,
      };
    case CREATE_PROJECT_REJECTED:
      return {
        ...state,
        ...initialState,
        createProjectLoading: false,
        createProjectId: false,
        error: action.data.error,
      };    

    case PUT_PROJECT_MODEL_VALIDATE_LOADING:
      return {
        ...state,
        validateLoading: true,
      };
    case PUT_PROJECT_MODEL_VALIDATE_FULFILLED:
      return {
        ...state,
        validateLoading: false,
        validateMessage: action.data,
      };
    case PUT_PROJECT_MODEL_VALIDATE_REJECTED:
      return {
        ...state,
        ...initialState,
        validateLoading: false,
      };
    case GET_LAYER_RECO_LOADING:
      return {
        ...state,
        recommendations: [],
        recommendationsLoading: true,
      };
    case GET_LAYER_RECO_FULFILLED:
      return {
        ...state,
        recommendations: action.data.recommendations,
        recommendationsLoading: false,
      };
    case GET_LAYER_RECO_REJECTED:
      return {
        ...state,
        recommendations: [],
        recommendationsLoading: false,
      };


    case GET_PROJECT_REMOVE_LOADING:
      return {
        ...state,
        removeLoading: true,
        removeError: null,
        removeSuccess: undefined,
      };
    case GET_PROJECT_REMOVE_FULFILLED:
      return {
        ...state,
        removeLoading: false,
        removeError: null,
        removeSuccess: true,
      };
    case GET_PROJECT_REMOVE_REJECTED:
      return {
        ...state,
        ...initialState,
        removeLoading: false,
        removeError: action.error,
        removeSuccess: null,
      };
    case GET_PROJECT_DUPLICATE_LOADING:
      return {
        ...state,
        duplicateLoading: true,
        duplicateError: null,
        duplicateProjectId: null,
      };
    case GET_PROJECT_DUPLICATE_FULFILLED:
      return {
        ...state,
        duplicateLoading: false,
        duplicateError: null,
        duplicateProjectId: action.data?.projectId,
      };
    case GET_PROJECT_DUPLICATE_REJECTED:
      return {
        ...state,
        ...initialState,
        duplicateLoading: false,
        duplicateError: action.error,
        duplicateProjectId: null,
      };

    case GET_PROJECT_DOWNLOAD_LOADING:
      return {
        ...state,
        projectDownloading: true,
        projectDownloadError: null,
        projectDownloadSuccess: null,
      };
    case GET_PROJECT_DOWNLOAD_FULFILLED:
      return {
        ...state,
        projectDownloading: false,
        projectDownloadError: null,
        projectDownloadSuccess: true,
      };
    case GET_PROJECT_DOWNLOAD_REJECTED:
      return {
        ...state,
        ...initialState,
        projectDownloading: false,
        projectDownloadError: action.data,
        projectDownloadSuccess: false,
      };
    default:
      return state;
  }
};

export default projectDataReducer;
